module.exports = __webpack_public_path__ + "static/media/exit.d62cd70b.png";